import React, { useRef, useState, useEffect } from 'react';

const CarouselSlide = ({ src, alt, eager = false, ...props }) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(eager);

  useEffect(() => {
    if (eager) return;
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { root: null, rootMargin: '200% 100%', threshold: 0 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [eager]);

  return (
    <img
      ref={ref}
      src={inView ? src : undefined}
      alt={alt}
      loading={eager ? 'eager' : 'lazy'}
      decoding="async"
      fetchpriority={eager ? 'high' : 'auto'}
      {...props}
    />
  );
};

export default CarouselSlide;
